module.exports = __webpack_public_path__ + "img/fachadas-moviles.6c3b368b.gif";